import { useCallback } from "react";
import { useWatcherPropName } from "./useWatcherPropName";
import { WatcherObject } from "@adsk/acc-issues-types";

export const useGetWatchersValue = () => {
  const watcherPropName = useWatcherPropName();
  const getWatchersValue = useCallback(
    (newWatcherObjectValues: WatcherObject[]) => {
      if (watcherPropName === "watchers") {
        return newWatcherObjectValues.map(x => x.id);
      } else {
        return newWatcherObjectValues;
      }
    },
    [watcherPropName]
  );
  return {
    getWatchersValue,
  };
};
